import React, { useState, useEffect } from "react";
const ContactForm = () => {
  return (
    <section
      style={{ backgroundImage: 'url("/img/full/27.jpg")' }}
      id="contact-us"
      className="section-padding dark-bg bg-image overlay-dark60"
      data-background-img="/img/full/20.jpg"
      data-stellar-background-ratio="0.5"
    >
      <div className="container">
        <div className="row text-center">
          <div className="col-12">
            <h6 className="page-title-alt color mb-15">Wanna say hello? </h6>
            <h2 className="page-title">
              Get In <span className="text-light">Touch</span>
            </h2>
          </div>
        </div>
        <div className="row">
          <div className="col-md-8 offset-md-2">
            <form id="contact" className="row contact-form" role="form">
              <div className="col-md-12 text-center">
                <h5 className="successContent">
                  <i
                    className="fa fa-check left"
                    style={{ color: "#5cb45d" }}
                  />
                  Your message has been sent successfully.
                </h5>
                <h5 className="errorContent" style={{ color: "#e1534f" }}>
                  <i className="fa fa-exclamation-circle left" />
                  There was a problem validating the form please check!
                </h5>
              </div>
              <div className="col-md-6">
                <div className="form-field-wrapper">
                  <input
                    className="input-md form-full"
                    id="form-name"
                    type="text"
                    name="form-name"
                    placeholder="Your Name"
                    required=""
                  />
                </div>
                <div className="form-field-wrapper">
                  <input
                    className="input-md form-full"
                    id="form-email"
                    type="email"
                    name="form-email"
                    placeholder="Email"
                    required=""
                  />
                </div>
                <div className="form-field-wrapper">
                  <input
                    className="input-md form-full"
                    id="form-subject"
                    type="text"
                    name="form-subject"
                    placeholder="Subject"
                  />
                </div>
              </div>
              <div className="col-md-6 mb-0">
                <div className="form-field-wrapper">
                  <textarea
                    className="input-md form-full"
                    id="form-message"
                    rows={7}
                    name="form-message"
                    placeholder="Your Message"
                    required=""
                    defaultValue={""}
                  />
                </div>
              </div>
              <div className="col-md-12 text-center">
                <button
                  className="btn-contact-submit btn btn-md btn-color"
                  type="submit"
                  id="form-submit"
                  name="submit"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
